import options from './autocomplete.component';

export default {
    selector: 'dtEntitiesAutocomplete',
    options
};
